import React, { useEffect } from "react";
import TalabalarCard from "@/components/talabalar/talabalar_card";
import CustomTitle from "@/components/custom_title";
import BigFotoBack from "@/components/bigFotoBack/BigFotoBack";
import Layout from "@/locales/en/layout/Layout";
import { useQuery } from "react-query";
import { getTalabaMagistr } from "@/api/general";
import { useTranslation } from "react-i18next";
import bg from "../../../assets/bolimlar/Magistratura.jpg"

function Magistratura() {
  const { data } = useQuery({
    queryKey: "talaba-mag",
    queryFn: () => getTalabaMagistr(),
  });
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <Layout>
      <BigFotoBack
        img={bg}
        text={t("header.header__bottom__nav__item__menu.menu-4.item-42")}
      />
      <CustomTitle
        name={t("header.header__bottom__nav__item__menu.menu-4.item-42")}
      />
      <TalabalarCard data={data?.data?.data} />
    </Layout>
  );
}

export default Magistratura;
